import React from 'react';
import { Button } from '@podiumhq/design-system';
import styled from 'styled-components/macro';

import icon from './unexpected-error.svg';

const ErrorView = () => {
  return (
    <ErrorContainer>
      <img src={icon} alt="Error" css="width: 168px; height: auto" />
      <h1>Uh oh!</h1>
      <ErrorMessage>
        Hmmm... looks like something went wrong on our end.
      </ErrorMessage>
      <Button variant="primary" onClick={() => window.location.reload()}>
        Reload Page
      </Button>
    </ErrorContainer>
  );
};

const ErrorContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const ErrorMessage = styled.p`
  padding-bottom: 30px;
`;

export default ErrorView;
